import React from "react"
import styled from "styled-components"
import LeftChevron from "../../../../common/components/LeftChevron"
import HeaderLabel from "./HeaderLabel"

const BackButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 16px 0 20px;
  label {
    margin: 0 0 0 3px;
  }
`
const BackIcon = styled(LeftChevron)`
  margin-right: 3px;
`

const BackButton = ({ onClick }) => (
  <BackButtonContainer onClick={onClick}>
    <BackIcon />
    <HeaderLabel>BACK</HeaderLabel>
  </BackButtonContainer>
)

export default BackButton



// WEBPACK FOOTER //
// ./assets/feedback/components/postIntent/components/BackButton.js